<template>
	<div class="copyright two">
		<div class="container">
			<div class="row">
				<div class="col-12 text-center">
					<div class="hidden-xs" style="display: flex;justify-content: center;">
						<div style="display: flex;flex-direction: column;align-items: flex-end;">
							<p class="text">主办单位：徐州市政府采购协会
							</p>
							<p class="text" style="margin: 7px 0;">联系方式：15366765780、0516-83953505
							</p>
						</div>
						<div>
							<p class="text" style="margin:0 15px;">|</p>
							<p class="text" style="margin:0 15px;margin-top: 7px;">|</p>
						</div>
						<div style="display: flex;flex-direction: column;align-items: flex-start;">
							<p class="text">备案号：苏ICP备19041028号-1
							</p>
							<p class="text" style="margin: 7px 0;">版权所有：苏采学在线培训学习平台
							</p>
						</div>
					</div>
					<div class="visible-xs-block">
						<div style="display: flex;justify-content: center;">
							<p class="text">主办单位：徐州市政府采购协会
							</p>
						</div>
						<div style="display: flex;justify-content: center;">
							<p class="text" style="margin: 7px 0;">联系方式：15366765780、0516-83953505
							</p>
						</div>
						<div style="display: flex;justify-content: center;">
							<p class="text">备案号：苏ICP备19041028号-1
							</p>
						</div>
						<div style="display: flex;justify-content: center;">
							<p class="text" style="margin: 7px 0;">版权所有：苏采学在线培训学习平台
							</p>
						</div>
					</div>
					<div style="display: flex;justify-content: center;">
						<p class="text">技术支持：江苏新蝉网络科技有限公司
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "Footer",
		data() {
			return {

			};
		}
	};
</script>
<style scoped>
	.footer-area {
		background-color: #333;
		display: flex;
		align-items: center;
		justify-content: center;
		color: #fff;
		font-size: 16px;
		height: 104px;
		width: 100%;
		text-align: center;
	}
</style>